var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("navigation-widget", [], factory);else if (typeof exports === 'object') exports["navigation-widget"] = factory();else root["navigation-widget"] = factory();
})(this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};
      /******/
      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/
        module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/
      __webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/
      __webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/
      __webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/
      __webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/
        if (mode & 8) return value;
        /******/
        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/
        var ns = Object.create(null);
        /******/
        __webpack_require__.r(ns);
        /******/
        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/
        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/
        return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/
      __webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ? /******/function getDefault() {
          return module['default'];
        } : /******/function getModuleExports() {
          return module;
        };
        /******/
        __webpack_require__.d(getter, 'a', getter);
        /******/
        return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/
      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/
      __webpack_require__.p = "/dist/";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/
      return __webpack_require__(__webpack_require__.s = 8);
      /******/
    }
    /************************************************************************/
    /******/([/* 0 */
    /***/function (module, exports) {
      module.exports = require("react");

      /***/
    }, /* 1 */
    /***/function (module, exports, __webpack_require__) {
      // extracted by mini-css-extract-plugin
      module.exports = {
        "popup": "popup___3n06X",
        "title": "title___1FMFz",
        "projects": "projects___1XXwv",
        "projectsWrapper": "projectsWrapper___eGfub",
        "footer": "footer___3zqii",
        "link": "link___36fsK",
        "brand": "brand___1MNAA",
        "outerTriangle": "outerTriangle___2K947",
        "innerTriangle": "innerTriangle___j84_d"
      };

      /***/
    }, /* 2 */
    /***/function (module, exports, __webpack_require__) {
      // extracted by mini-css-extract-plugin
      module.exports = {
        "navbar": "navbar___3SVld",
        "container": "container___E0DqP",
        "brand": "brand___ZOIKE",
        "logo": "logo___1fq4T",
        "menu": "menu___2CAGc",
        "menuIcon": "menuIcon___2xOq1",
        "background": "background___1IeG_"
      };

      /***/
    }, /* 3 */
    /***/function (module, exports, __webpack_require__) {
      // extracted by mini-css-extract-plugin
      module.exports = {
        "project": "project___1BAp9",
        "logoContainer": "logoContainer___Meavc",
        "logo": "logo___3_TWX",
        "text": "text___3QXl6",
        "title": "title___290yb",
        "description": "description___2DI-M"
      };

      /***/
    }, /* 4 */
    /***/function (module, exports) {
      module.exports = require("prop-types");

      /***/
    }, /* 5 */
    /***/function (module, exports) {
      module.exports = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0_2_15)'%3e %3cpath d='M0 3.33643V4.99999H11.4684L0 16.4684L1.1803 17.6487L15.4926 3.33643H0Z' fill='%23F7B749'/%3e %3cpath d='M17.1561 1.66357L18.829 0H0V1.66357H17.1561Z' fill='%23ED362F'/%3e %3cpath d='M18.3364 2.84387V20H20V1.1803L18.3364 2.84387Z' fill='%2343B85C'/%3e %3cpath d='M16.6729 20V4.51672L2.3606 18.8197L3.54089 20L15 8.54089V20H16.6729Z' fill='%232CB4E2'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_2_15'%3e %3crect width='20' height='20' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";

      /***/
    }, /* 6 */
    /***/function (module, exports) {
      module.exports = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M4 0H0V4H4V0Z' fill='white'/%3e %3cpath d='M12 0H8V4H12V0Z' fill='white'/%3e %3cpath d='M20 0H16V4H20V0Z' fill='white'/%3e %3cpath d='M4 8H0V12H4V8Z' fill='white'/%3e %3cpath d='M12 8H8V12H12V8Z' fill='white'/%3e %3cpath d='M20 8H16V12H20V8Z' fill='white'/%3e %3cpath d='M4 16H0V20H4V16Z' fill='white'/%3e %3cpath d='M12 16H8V20H12V16Z' fill='white'/%3e %3cpath d='M20 16H16V20H20V16Z' fill='white'/%3e %3c/svg%3e";

      /***/
    }, /* 7 */
    /***/function (module, exports, __webpack_require__) {

      // extracted by mini-css-extract-plugin

      /***/}, /* 8 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      // ESM COMPAT FLAG
      __webpack_require__.r(__webpack_exports__);

      // EXTERNAL MODULE: external "react"
      var external_react_ = __webpack_require__(0);
      var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

      // EXTERNAL MODULE: ./src/styles/styles.scss
      var styles = __webpack_require__(7);

      // EXTERNAL MODULE: ./src/components/project/index.module.scss
      var index_module = __webpack_require__(3);
      var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);

      // CONCATENATED MODULE: ./src/components/project/project.js
      /**
       * Copyright 2020 OpenStack Foundation
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       * http://www.apache.org/licenses/LICENSE-2.0
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       **/

      var Project = function Project(_ref2) {
        var project = _ref2.project;
        return /*#__PURE__*/external_react_default.a.createElement("a", {
          href: project.site_url,
          target: "_blank",
          rel: "noreferrer noopener",
          className: index_module_default.a.project
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: index_module_default.a.logoContainer
        }, /*#__PURE__*/external_react_default.a.createElement("img", {
          className: index_module_default.a.logo,
          src: project.logo_url,
          alt: project.name
        })), /*#__PURE__*/external_react_default.a.createElement("div", {
          className: index_module_default.a.text
        }, /*#__PURE__*/external_react_default.a.createElement("span", {
          className: index_module_default.a.title
        }, project.name), /*#__PURE__*/external_react_default.a.createElement("span", {
          className: index_module_default.a.description,
          dangerouslySetInnerHTML: {
            __html: project.description
          }
        })));
      };

      /* harmony default export */
      var project_project = Project;
      // EXTERNAL MODULE: ./src/components/popup/index.module.scss
      var popup_index_module = __webpack_require__(1);
      var popup_index_module_default = /*#__PURE__*/__webpack_require__.n(popup_index_module);

      // EXTERNAL MODULE: ./src/assets/openinfra-logo.svg
      var openinfra_logo = __webpack_require__(5);
      var openinfra_logo_default = /*#__PURE__*/__webpack_require__.n(openinfra_logo);

      // CONCATENATED MODULE: ./src/components/popup/popup.js
      /**
       * Copyright 2020 OpenStack Foundation
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       * http://www.apache.org/licenses/LICENSE-2.0
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       **/

      var Popup = function Popup(_ref3) {
        var projects = _ref3.projects,
          popupTitle = _ref3.popupTitle,
          popupFooterText = _ref3.popupFooterText;
        return /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.popup
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.outerTriangle
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.innerTriangle
        })), /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.title
        }, popupTitle, /*#__PURE__*/external_react_default.a.createElement("hr", null)), /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.projects
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.projectsWrapper
        }, projects.map(function (project, index) {
          return /*#__PURE__*/external_react_default.a.createElement(project_project, {
            project: project,
            key: index
          });
        })), /*#__PURE__*/external_react_default.a.createElement("hr", null)), /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.footer
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: popup_index_module_default.a.brand
        }, /*#__PURE__*/external_react_default.a.createElement("img", {
          src: openinfra_logo_default.a
        }), /*#__PURE__*/external_react_default.a.createElement("span", null, "OpenInfra Foundation")), /*#__PURE__*/external_react_default.a.createElement("span", {
          className: popup_index_module_default.a.link
        }, popupFooterText, " ", /*#__PURE__*/external_react_default.a.createElement("a", {
          href: 'https://openinfra.dev',
          target: "_blank",
          rel: "noreferrer noopener"
        }, "openinfra.dev"))));
      };

      /* harmony default export */
      var popup = Popup;
      // EXTERNAL MODULE: ./src/components/navbar/index.module.scss
      var navbar_index_module = __webpack_require__(2);
      var navbar_index_module_default = /*#__PURE__*/__webpack_require__.n(navbar_index_module);

      // EXTERNAL MODULE: ./src/assets/menu-icon.svg
      var menu_icon = __webpack_require__(6);
      var menu_icon_default = /*#__PURE__*/__webpack_require__.n(menu_icon);

      // CONCATENATED MODULE: ./src/components/navbar/navbar.js
      /**
       * Copyright 2020 OpenStack Foundation
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       * http://www.apache.org/licenses/LICENSE-2.0
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       **/

      var Navbar = function Navbar(_ref4) {
        var projects = _ref4.projects,
          currentProject = _ref4.currentProject,
          containerClass = _ref4.containerClass,
          navbarTitle = _ref4.navbarTitle,
          popupTitle = _ref4.popupTitle,
          popupFooterText = _ref4.popupFooterText;
        var _Object = Object(external_react_["useState"])(false),
          _Object2 = _slicedToArray(_Object, 2),
          isOpen = _Object2[0],
          setIsOpen = _Object2[1];
        var handleMenuClick = function handleMenuClick() {
          setIsOpen(!isOpen);
        };
        return /*#__PURE__*/external_react_default.a.createElement("nav", {
          className: navbar_index_module_default.a.navbar
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: "".concat(navbar_index_module_default.a.container, " ").concat(containerClass)
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: navbar_index_module_default.a.brand
        }, /*#__PURE__*/external_react_default.a.createElement("div", {
          className: navbar_index_module_default.a.logo
        }, /*#__PURE__*/external_react_default.a.createElement("img", {
          src: openinfra_logo_default.a,
          alt: "OpenInfra"
        })), navbarTitle), /*#__PURE__*/external_react_default.a.createElement("div", {
          className: navbar_index_module_default.a.menu
        }, /*#__PURE__*/external_react_default.a.createElement("img", {
          className: navbar_index_module_default.a.menuIcon,
          src: menu_icon_default.a,
          onClick: handleMenuClick,
          alt: "Menu"
        }), isOpen && /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(popup, {
          projects: projects,
          currentProject: currentProject,
          popupTitle: popupTitle,
          popupFooterText: popupFooterText
        }), /*#__PURE__*/external_react_default.a.createElement("div", {
          className: navbar_index_module_default.a.background,
          onClick: function onClick() {
            return setIsOpen(false);
          }
        })))));
      };

      /* harmony default export */
      var navbar = Navbar;
      // CONCATENATED MODULE: ./src/components/navigation.js
      var _excluded = ["projects", "currentProject"];
      function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends.apply(this, arguments);
      }
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }

      /**
       * Copyright 2020 OpenStack Foundation
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       * http://www.apache.org/licenses/LICENSE-2.0
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       **/

      var NavigationWidget = function NavigationWidget(_ref) {
        var projects = _ref.projects,
          currentProject = _ref.currentProject,
          props = _objectWithoutProperties(_ref, _excluded);
        var activeProject = projects.find(function (e) {
          return e.id === currentProject;
        });
        var filteredProjects = projects.filter(function (e) {
          return e.should_show_on_nav_bar && e.is_active && e.id !== currentProject;
        });
        return /*#__PURE__*/external_react_default.a.createElement(navbar, _extends({
          projects: filteredProjects,
          currentProject: activeProject
        }, props));
      };

      /* harmony default export */
      var navigation = NavigationWidget;
      // EXTERNAL MODULE: external "prop-types"
      var external_prop_types_ = __webpack_require__(4);
      var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

      // CONCATENATED MODULE: ./src/navigation-widget.js
      function navigation_widget_extends() {
        navigation_widget_extends = Object.assign ? Object.assign.bind() : function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return navigation_widget_extends.apply(this, arguments);
      }

      /**
       * Copyright 2017 OpenStack Foundation
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       * http://www.apache.org/licenses/LICENSE-2.0
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       **/

      var navigation_widget_NavigationWidget = function navigation_widget_NavigationWidget(_ref) {
        var props = navigation_widget_extends({}, _ref);
        return /*#__PURE__*/external_react_default.a.createElement(navigation, props);
      };
      navigation_widget_NavigationWidget.propTypes = {
        projects: external_prop_types_default.a.array.isRequired,
        currentProject: external_prop_types_default.a.number.isRequired,
        containerClass: external_prop_types_default.a.string,
        navbarTitle: external_prop_types_default.a.string,
        popupTitle: external_prop_types_default.a.string,
        popupFooterText: external_prop_types_default.a.string
      };
      navigation_widget_NavigationWidget.defaultProps = {
        projects: [],
        currentProject: 0,
        containerClass: '',
        navbarTitle: 'An OpenInfra Project',
        popupTitle: 'More OpenInfra Projects',
        popupFooterText: 'Learn more at'
      };
      /* harmony default export */
      var navigation_widget = __webpack_exports__["default"] = navigation_widget_NavigationWidget;

      /***/
    }
    /******/])
  );
});